import { HTTP_INTERCEPTORS }           from '@angular/common/http';
import { XClientAnalyticsInterceptor } from '@interceptors/x-client-analytics.interceptor';
import { XClientInterceptor }          from '@interceptors/x-client.interceptor';
import { XTenantInterceptor }          from '@interceptors/x-tenant.interceptor';

/** Http interceptor providers in outside-in order */
export const httpInterceptorProviders = [
	{ provide: HTTP_INTERCEPTORS, useClass: XTenantInterceptor, multi: true },
	{ provide: HTTP_INTERCEPTORS, useClass: XClientInterceptor, multi: true },
	{ provide: HTTP_INTERCEPTORS, useClass: XClientAnalyticsInterceptor, multi: true }
];
